// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2vKto","header":"PatientQuestionnaire_header__3_-UE","info":"PatientQuestionnaire_info__2xC7W"};